export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=708ca55344f1c41bfbfa1ea7257f77b6ee155b1155&name=pushAdClickData!'